module.exports = __webpack_public_path__ + "media/assets/images/zitensya_first_view_botton-3f4b1ce9d2ae00967f7258b5b1425a40.png";